module.exports = __webpack_public_path__ + "img/9.e6725b29.jpg";